import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define Restaurant interface based on API response
export interface Restaurant {
  restaurantId: string;
  phone: string | null;
  cuisineType: string | null;
  name: string;
  image: string | null;
  logo: string[];
  state: string | null;
  country: string | null;
  zipcode: string | null;
  address: string;
  alternativePhone: string | null;
  owner: string | null;
}

// Define slice state interface
interface RestaurantState {
  restaurants: Restaurant[];
  selectedRestaurantId: string | null;
  loading: boolean;
  error: string | null;
}

// Define initial state
const initialState: RestaurantState = {
  restaurants: [],
  selectedRestaurantId: null,
  loading: false,
  error: null,
};

export const restaurantSlice = createSlice({
  name: 'restaurant',
  initialState,
  reducers: {
    // Fetch restaurants actions
    fetchRestaurantsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchRestaurantsSuccess: (state, action: PayloadAction<Restaurant[]>) => {
      state.loading = false;
      state.restaurants = action.payload;
      state.error = null;
    },
    fetchRestaurantsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    // Set selected restaurant ID
    setSelectedRestaurantId: (state, action: PayloadAction<string>) => {
      state.selectedRestaurantId = action.payload;
    },
    // Clear selected restaurant ID
    clearSelectedRestaurantId: (state) => {
      state.selectedRestaurantId = null;
    },
    // Clear restaurants
    clearRestaurants: (state) => {
      state.restaurants = [];
      state.selectedRestaurantId = null;
      state.loading = false;
      state.error = null;
    },
  },
});

// Export actions
export const {
  fetchRestaurantsRequest,
  fetchRestaurantsSuccess,
  fetchRestaurantsFailure,
  setSelectedRestaurantId,
  clearSelectedRestaurantId,
  clearRestaurants,
} = restaurantSlice.actions;

export default restaurantSlice.reducer;
